import React from 'react'
import {
  calculatePasswordStrength,
  getPasswordStrength,
  getStrengthColor,
  getStrengthTextColor,
} from '@/utils/passwordValidation'

interface PasswordStrengthIndicatorProps {
  password: string
  className?: string
}

export const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({
  password,
  className = '',
}) => {
  const score = calculatePasswordStrength(password)
  const strength = getPasswordStrength(score)
  const colorClass = getStrengthColor(strength)
  const textColorClass = getStrengthTextColor(strength)

  // Only show indicator if password has been entered
  if (!password) {
    return null
  }

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Progress bar */}
      <div className="relative pt-1">
        <div className="overflow-hidden h-2 text-xs flex rounded-full bg-neutral-200">
          <div
            style={{ width: `${score}%` }}
            className={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center transition-all duration-300 ${colorClass}`}
          />
        </div>
      </div>

      {/* Strength label */}
      <div className="flex items-center justify-between">
        <span className="text-xs text-neutral-600">Password strength:</span>
        <span className={`text-xs font-semibold ${textColorClass} capitalize`}>
          {strength}
        </span>
      </div>
    </div>
  )
}
